import { getAccessToken } from '@/auth/tokenStore';
import { resolvedManualTradingOrigin, toWsBase } from '@/config/api';

/** 与 trading-engine `FrontendEvent` 对齐的标准事件模板 */
export type EventCategory = 'instruction' | 'order' | 'task' | 'system';
export type EventSeverity = 'info' | 'success' | 'warning' | 'error';

export interface EventEntity {
  kind: string;
  id: string;
  parent_id?: string;
}

export interface OrderFilledEventData {
  task_id?: string;
  instruction_id?: string;
  exchange?: string;
  inst_id?: string;
  client_order_id?: string;
  symbol?: string;
  filled_price?: number;
  token_size?: number;
  notional_usd?: number;
}

export interface TradingEvent {
  id: string;
  category: EventCategory;
  action: string;
  severity: EventSeverity;
  title: string;
  message: string;
  user_id: string;
  ts_ms: number;
  entity: EventEntity;
  data?: OrderFilledEventData & Record<string, unknown>;
}

export type TradingWsMessage =
  | { type: 'connected'; user_id: string; ts_ms: number }
  | { type: 'heartbeat'; ts_ms: number }
  | ({ type: 'event' } & TradingEvent);

export function tradingEventsWsUrl(token?: string | null): string | null {
  const accessToken = token ?? getAccessToken();
  if (!accessToken) return null;
  const wsBase = toWsBase(resolvedManualTradingOrigin()).replace(/\/+$/, '');
  return `${wsBase}/ws/events?token=${encodeURIComponent(accessToken)}`;
}

export function parseTradingWsMessage(raw: string): TradingWsMessage | null {
  try {
    const payload = JSON.parse(raw) as TradingWsMessage;
    if (!payload || typeof payload !== 'object' || !('type' in payload)) {
      return null;
    }
    return payload;
  } catch {
    return null;
  }
}
